import { net } from 'zf-web-infra';
import { type GetParams, type PostParams } from 'zf-web-components/widgets';

class Fetcher {

  async get<R, P>(path: string, params: GetParams<P>): Promise<R> {
    return await net.get<R>(path, params.params);
  }

  async post<R, P>(path: string, params: PostParams<P>): Promise<R> {
    return await net.post<R>(path, params.body);
  }

}

export const fetcher = new Fetcher();
